export interface ListProps<T> {
  data: T[]
  renderItem: (item: T, index: number) => JSX.Element
}

const List = <T,>({ data, renderItem }: ListProps<T>) => data.map(renderItem)

export default List
